import { trimmValue } from '../helpers';

export const minLength = (message: string, length: number) => (value: any) => {
  const trimmedValue = trimmValue(value);
  return trimmedValue && trimmedValue.length < length ? message : undefined;
};
